<template>
    <el-container>
      <div class="container">
          <div class="contentBox" >
            <el-table :data="tableData">
                <el-table-column  width="180">
                  <template slot="header" slot-scope="scope">
                      分公司
                  </template>
                  <template slot-scope="scope">
                    {{scope.row.company }}
                  </template>
                </el-table-column>
                <el-table-column prop="contractProcessYear"  width="360" >
                  <template slot="header" slot-scope="scope">
                      <el-link @click="clickExportOut('all',yearInfo.start,yearInfo.end,'Processing')">{{ label1 }}</el-link>
                  </template>
                  <template  slot-scope="scope">
                      <el-link @click="clickExportOut(scope.row.company,yearInfo.start,yearInfo.end,'Processing')">{{scope.row.contractProcessYear }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="contractUploadedWeak"  width="360">
                  <template slot="header" slot-scope="scope">
                      <el-link @click="clickExportOut('all',weekInfo.start,weekInfo.end,'Uploaded')">{{ label2 }}</el-link>
                  </template>
                  <template  slot-scope="scope">
                      <el-link @click="clickExportOut(scope.row.company,weekInfo.start,weekInfo.end,'Uploaded')">{{scope.row.contractUploadedWeak }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="contractFinishMonth"  width="360">
                  <template slot="header" slot-scope="scope">
                      <el-link @click="clickExportOut('all',monthInfo.start,monthInfo.end,'Finished')">{{ label3 }}</el-link>
                  </template>
                  <template  slot-scope="scope">
                      <el-link @click="clickExportOut(scope.row.company,monthInfo.start,monthInfo.end,'Finished')">{{scope.row.contractFinishMonth }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="contractFinishYear"  width="360">
                  <template slot="header" slot-scope="scope">
                      <el-link @click="clickExportOut('all',yearInfo.start,yearInfo.end,'Finished')">{{ label5 }}</el-link>
                  </template>
                  <template  slot-scope="scope">
                      <el-link @click="clickExportOut(scope.row.company,yearInfo.start,yearInfo.end,'Finished')">{{scope.row.contractFinishYear }}</el-link>
                  </template>
                </el-table-column>

                <el-table-column prop="contractReceiveMoney"  width="360">
                  <template slot="header" slot-scope="scope">
                      <el-link @click="clickExportOut('all',yearInfo.start,yearInfo.end,'Charged')">{{ label4 }}</el-link>
                  </template>
                  <template  slot-scope="scope">
                      <el-link @click="clickExportOut(scope.row.company,yearInfo.start,yearInfo.end,'Charged')">{{scope.row.contractReceiveMoney }}</el-link>
                  </template>
                </el-table-column>
            </el-table>
          </div>
      </div>
    </el-container>
</template>

<script>

// eslint-disable-next-line no-unused-vars
import { getYear, getMonth, getWeek } from '../../lib/misc'
import request from '@/lib/utils'

export default {
  name: 'contracts',
  data () {
    return {
      tableData: [],
      label1: '审批中(本年度 2025-01-01 - 2025-12-31)',
      label2: '已上传合约(本周 2025-01-03 - 2025-01-09)',
      label3: '已完工(本月 2025-01-01 - 2025-01-31)',
      label4: '已收款(本年度 2025-01-01 - 2025-12-31)',
      label5: '',
      yearInfo: {},
      weekInfo: {},
      monthInfo: {}
    }
  },
  methods: {
    queryTableData () {
      request.get('/contract/queryFixSummary').then(
        (response) => {
          if (response.code === 'success') {
            this.tableData = response.obj
          }
        }
      )
    },
    clickExportOut (company, start, end, type) {
      let exportUrl = process.env.API_URL + 'contract/exportFixDetail?company=' + company + '&start=' + start + '&end=' + end + '&category=' + type + '&auth_token=' + localStorage.getItem('auth-token')
      window.open(exportUrl)
    }
  },
  mounted () {
    const yearInfo = getYear()
    this.yearInfo = yearInfo
    this.label1 = '审批中(本年度 ' + yearInfo.start + ' - ' + yearInfo.end + ' )'
    const weekInfo = getWeek(4, 5)
    // const weekInfo = {}
    // weekInfo.start = '2025-04-25'
    // weekInfo.end = '2025-05-08'
    this.weekInfo = weekInfo
    this.label2 = '已上传合约(本周 ' + weekInfo.start + ' - ' + weekInfo.end + ' )'
    const monthInfo = getMonth()
    this.monthInfo = monthInfo
    this.label3 = '已完工(本月' + monthInfo.start + ' - ' + monthInfo.end + ' )'
    this.label4 = '已收款(本年度 ' + yearInfo.start + ' - ' + yearInfo.end + ' )'
    this.label5 = '已完工(本年 ' + yearInfo.start + ' - ' + yearInfo.end + ' )'
    this.queryTableData()
  }
}

</script>

<style scoped>

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contentBox{
    width: 80%;
    margin-top: 50px;
  }
  .el-link{
    color:palevioletred
  }

</style>



// WEBPACK FOOTER //
// src/page/subPage/Contracts.vue